/* CAR ELECTRIC – Anfragen bleiben im Shop (12.10.2026, Vorgabe Juli)
   Früher: Weiterleitung zur Terminanfrage auf car-electric.de. Jetzt:
   – Jeder Link zu car-electric.de mit „kontakt“, „termin“ oder „anfrage“ führt auf die
     Kontaktseite des Shops (/pages/kontakt) mit vorausgewähltem Thema:
     utm_content enthält echeck oder fehlersuche → E-Check, schulung oder b2b → B2B,
     reklamation → Reklamation, sonst → Einbau.
   – Links zu car-electric.de/einbau führen auf die eigene Einbau-Seite.
   – Auf Produktseiten bekommen Kontakt-Links (alte und neue) den Artikel mit
     (&artikel=Name&sku=Artikelnummer), im Warenkorb beim Klick alle Artikel im Warenkorb.
   Inhalts-Links auf car-electric.de (Projekte, Autarkiepakete, Fragen) bleiben unverändert. */
(function () {
  'use strict';
  var KONTAKT = '/pages/kontakt';
  var EINBAU_SEITE = '/pages/camperwerkstatt';
  function url(href) { try { return new URL(href, window.location.href); } catch (e) { return null; } }
  function istAlterKontakt(u) { return u && /car-electric\.de$/i.test(u.hostname) && /kontakt|termin|anfrage/i.test(u.pathname + u.hash); }
  function istAlteEinbauSeite(u) { return u && /car-electric\.de$/i.test(u.hostname) && /^\/einbau\/?$/i.test(u.pathname); }
  function istShopKontakt(u) { return u && u.origin === window.location.origin && u.pathname.replace(/\/$/, '') === KONTAKT; }
  function themaAus(u) {
    var c = ((u.searchParams.get('utm_content') || '') + ' ' + u.pathname).toLowerCase();
    if (/echeck|e-check|fehlersuche|service/.test(c)) return 'echeck';
    if (/schulung|b2b|werkstaetten|haendler/.test(c)) return 'b2b';
    if (/reklamation/.test(c)) return 'reklamation';
    return 'einbau';
  }
  function produktDaten(scope) {
    var box = (scope && scope.closest && scope.closest('[data-ce-produkt]')) || document.querySelector('[data-ce-produkt]');
    if (!box) return null;
    var og = document.querySelector('meta[property="og:title"]');
    var h1 = box.querySelector('.product__title');
    var titel = (og && og.getAttribute('content')) || (h1 && h1.firstChild && h1.firstChild.textContent) || '';
    var sku = box.querySelector('[data-sku]');
    return { titel: titel.trim(), sku: sku ? sku.textContent.trim() : '' };
  }
  function imWarenkorb(a) { return !!a.closest('.ce-wd, .wk__side, [data-ce-warenkorb-seite]'); }
  function ziel(u, thema, p) {
    var z = new URL(KONTAKT, window.location.origin);
    z.searchParams.set('thema', thema);
    if (p && p.titel) { z.searchParams.set('artikel', p.titel); if (p.sku) z.searchParams.set('sku', p.sku); }
    if (u && u.hash && !/kontakt|termin|anfrage/i.test(u.hash)) z.hash = u.hash;
    return z.pathname + z.search + z.hash;
  }
  function bearbeite(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('a[href]'), function (a) {
      if (a.hasAttribute('data-ce-kontakt')) return;
      var u = url(a.getAttribute('href'));
      if (!u) return;
      if (istAlteEinbauSeite(u)) { a.href = EINBAU_SEITE; a.removeAttribute('target'); return; }
      var alt = istAlterKontakt(u), neu = istShopKontakt(u);
      if (!alt && !neu) return;
      var thema = alt ? themaAus(u) : (u.searchParams.get('thema') || '');
      a.setAttribute('data-ce-kontakt', thema || '1');
      a.removeAttribute('target');
      if (imWarenkorb(a)) { a.href = ziel(u, thema || 'einbau', null); return; }
      var p = (thema === 'einbau' || thema === 'echeck' || thema === 'produkt') ? produktDaten(a) : null;
      if (alt) { a.href = ziel(u, thema, p); return; }
      if (p && p.titel && !u.searchParams.get('artikel')) {
        u.searchParams.set('artikel', p.titel); if (p.sku) u.searchParams.set('sku', p.sku);
        a.href = u.pathname + u.search + u.hash;
      }
    });
  }
  bearbeite(document);
  document.addEventListener('shopify:section:load', function (e) { bearbeite(e.target); });
  /* Im Warenkorb erst beim Klick den aktuellen Inhalt holen – der Warenkorb ändert sich ja laufend. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-ce-kontakt]');
    if (!a || !imWarenkorb(a)) return;
    e.preventDefault();
    var z = url(a.href);
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var t = [];
        (c.items || []).forEach(function (i) { var n = i.product_title + (i.sku ? ' (' + i.sku + ')' : ''); if (t.indexOf(n) === -1) t.push(n); });
        if (t.length && z) z.searchParams.set('artikel', t.join('; '));
      })
      .catch(function () {})
      .finally(function () { window.location.href = z ? z.pathname + z.search + z.hash : a.href; });
  });
})();
